var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconGreekBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23 5.652H1L12 .848l11 4.804zm-21 0h20v3.257H2zm8.184 3.258h3.632v8.971h-3.632zM3 8.91h3.632v8.971H3zm14.368 0H21v8.971h-3.632zM2 17.881h20v3.272H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1 23.152v-2h22v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconGreekBuilding);
export default __webpack_public_path__ + "static/media/streamline-icon-greek-building.47948a21.svg";
export { ForwardRef as ReactComponent };